import FirebaseModel from "@/Store/ORM/FirebaseORM/FirebaseModel";
import SampleTestType from "@/Store/ORM/SampleTestType";

export default class BillingTestPrice extends FirebaseModel {
	static entity = 'billingTestPrices';
	static baseCollection = this.firestore.collection('Configs').doc('Belit').collection('test_prices');
	static fields(){
		return {
			test_type_uuid: this.attr(null),
			default_pricing: this.number(null).nullable(),
			category_prices: this.attr(null),
			...super.fields(),
			test_type: this.belongsTo(SampleTestType, 'test_type_uuid', 'uuid')
		}
	}
	static ignoredFields(){
		return [
			...super.ignoredFields(),
			'test_type'
		]
	}
}
